/*
 * File size limiter. Shows warning text if files on input are too large
 * Size limit and warning text are set on HTML mockup .js.file.error data-max-filesize
*/

class FilesizeLimit {
  constructor() {
    this.fileInputs = document.querySelectorAll('.js-filesize-limit')
    this.warningClass = '.js-file-error'
    this.maxFilesize = this._getFileSizeLimit(document.querySelector('.js-filesize-limit'))
  }

  /*
   * @param {HTMLinputElement}
   * @return {number|false}
   */
  _getFileSizeLimit(input) {
    const limit = input.dataset.maxFilesize;
    return limit ? parseInt(limit) : false
  }


  /* Event lister for input file.
   * Checks if one of the files is too large and shows warning to  user
   *
   * @param {event}
   */
  _checkFileSize(e) {
    const target = e.target
    const files = target.files
    const parentDiv = target.closest('.form-group')
    const warningElm = parentDiv.querySelector(this.warningClass)
    const containerForm = target.closest('.stage-form')
    const submitButton = containerForm.querySelector('.js-submit-loader')

    if (!warningElm) {
      return
    }

    if (files.length < 1 ) {
      warningElm.classList.add('d-none')
      submitButton.disabled = false;
      return
    }

    files.forEach( (file) => {
      if ( file.size > this.maxFilesize ) {
        warningElm.classList.remove('d-none')
        target.setCustomValidity(warningElm.innerText);
        submitButton.disabled = true;
      } else {
        warningElm.classList.add('d-none')
        target.setCustomValidity('');
        submitButton.disabled = false;
      }
    })

    target.reportValidity();

  }

  /*
   * Init
   */
  init(){
    if (!this.fileInputs.length) {
      return
    }

    this.fileInputs.forEach( input => {
      input.addEventListener('change', this._checkFileSize.bind(this))
    })
      
  }
}

export default FilesizeLimit
